import { pick } from 'lodash';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { storableError } from '../../util/errors';
import { getStateFromHistory, isArrayLength } from '../../util/genericHelpers';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { parse } from '../../util/urlHelpers';
const RESULT_PAGE_SIZE = 90;

// ================ Action types ================ //

const ActionTypes = {
  SET_INITIAL_VALUES: 'app/FavoritesDetailsPage/SET_INITIAL_VALUES',
  FETCH_LISTING_REQUEST: 'app/FavoritesDetailsPage/FETCH_LISTING_REQUEST',
  FETCH_LISTING_SUCCESS: 'app/FavoritesDetailsPage/FETCH_LISTING_SUCCESS',
  FETCH_LISTING_ERROR: 'app/FavoritesDetailsPage/FETCH_LISTING_ERROR',
};

// ================ Initial State ================ //

const initialState = {
  fetchListingInProgress: false,
  fetchListingError: null,
  currentPageResultIds: [],
  pagination: null,
};
const resultIds = data => data.data.map(l => l.id);

// ================ Reducers ================ //

const FavoritesDetailsPageReducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case ActionTypes.SET_INITIAL_VALUES:
      return { ...initialState, ...payload };
    case ActionTypes.FETCH_LISTING_REQUEST:
      return {
        ...state,
        queryParams: payload.queryParams,
        fetchListingInProgress: true,
        currentPageResultIds: [],
        fetchListingError: null,
      };
    case ActionTypes.FETCH_LISTING_SUCCESS:
      return {
        ...state,
        currentPageResultIds: resultIds(payload.data),
        pagination: payload.data.meta,
        fetchListingInProgress: false,
      };
    case ActionTypes.FETCH_LISTING_ERROR:
      return {
        ...state,
        etchListingInProgress: false,
        fetchListingError: payload,
      };

    default:
      return state;
  }
};

// ================ Selectors ================ //

export const FavDetailsPageIds = state => state.FavoritesDetailsPage.currentPageResultIds;
export const FavDetailsPagePagination = state => state.FavoritesDetailsPage.pagination;
// ================ Actions Creators ================ //

export const setInitialValues = initialValues => ({
  type: ActionTypes.SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

const fetchListingRequest = queryParams => ({
  type: ActionTypes.FETCH_LISTING_REQUEST,
  payload: { queryParams },
});
const fetchListingSuccess = response => ({
  type: ActionTypes.FETCH_LISTING_SUCCESS,
  payload: { data: response.data },
});
const fetchListingError = error => ({
  type: ActionTypes.FETCH_LISTING_ERROR,
  error: true,
  payload: error,
});

// ================ Thunks ================ //
export const fetchListings = (params, config) => async (dispatch, getState, sdk) => {
  dispatch(fetchListingRequest(params));
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;
  try {
    const queryParams = {
      ...params,
      include: ['author', 'images', 'currentStock'],
      'fields.listing': ['title', 'geolocation', 'price', 'description', 'publicData'],
      'fields.user': ['profile.displayName', 'profile.abbreviatedName', 'profile.publicData'],
      'fields.image': [`variants.${variantPrefix}`, `variants.${variantPrefix}-2x`],
      ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
      ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
      'limit.images': 1,
    };

    const response = await sdk.listings.query(queryParams);
    dispatch(addMarketplaceEntities(response));
    dispatch(fetchListingSuccess(response));
    return response;
  } catch (error) {
    dispatch(fetchListingError(storableError(error)));
  }
};
export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  dispatch(
    setInitialValues({
      pagination: null,
      currentPageResultIds: [],
    })
  );
  const queryParams = parse(search, {
    latlng: ['origin'],
    latlngBounds: ['bounds'],
  });
  const stateFromHistory = getStateFromHistory();
  const listingIds = stateFromHistory?.state?.categoryIds || [];

  const { page = 1 } = queryParams || {};
  const currentUser = await dispatch(fetchCurrentUser({ enforce: true }));
  const currentUserId = currentUser?.id;
  if (isArrayLength(listingIds)) {
    dispatch(
      fetchListings(
        {
          ids: listingIds,
          page,
          perPage: RESULT_PAGE_SIZE,
        },
        config
      )
    );
  }

  return currentUser;
};

export default FavoritesDetailsPageReducer;
